import "./KeyMessage.css";

const PressAnyKey = () => {
  return (
    <div className="press-container">
      <p className="press-title">TOUCH TO START THE GAME </p>
    </div>
  );
};
export default PressAnyKey;
